module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Henniez_(Vaud)-740c22435671fd3faa16c71613ef3b7d.svg";